function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState, useEffect, useRef, useCallback, Component, forwardRef, useImperativeHandle, memo } from 'react';
import { useVideoPlayer } from './hooks/useVideoPlayer';
// Removed useApi import - ui-atoms should not have API dependencies
import { StyledVideo } from './styles';
import clsx from 'clsx';
// 에러 경계 컴포넌트
var VideoPlayerErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(VideoPlayerErrorBoundary, Component);
    function VideoPlayerErrorBoundary(props) {
        _class_call_check(this, VideoPlayerErrorBoundary);
        var _this;
        _this = _call_super(this, VideoPlayerErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false,
            error: null
        };
        return _this;
    }
    _create_class(VideoPlayerErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error('VideoPlayer 에러:', error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                if (this.state.hasError) {
                    var _this_state_error;
                    return /*#__PURE__*/ React.createElement("div", {
                        style: {
                            padding: '20px',
                            backgroundColor: 'rgba(0,0,0,0.8)',
                            color: 'white',
                            borderRadius: '8px',
                            textAlign: 'center'
                        }
                    }, /*#__PURE__*/ React.createElement("h3", null, "비디오 플레이어 오류"), /*#__PURE__*/ React.createElement("p", null, ((_this_state_error = this.state.error) === null || _this_state_error === void 0 ? void 0 : _this_state_error.message) || '알 수 없는 오류가 발생했습니다.'), /*#__PURE__*/ React.createElement("button", {
                        onClick: function() {
                            return _this.setState({
                                hasError: false,
                                error: null
                            });
                        },
                        style: {
                            background: 'rgba(255,255,255,0.2)',
                            border: 'none',
                            padding: '8px 16px',
                            borderRadius: '4px',
                            color: 'white',
                            cursor: 'pointer'
                        }
                    }, "다시 시도"));
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    error: error
                };
            }
        }
    ]);
    return VideoPlayerErrorBoundary;
}(Component);
/**
 * HLS 스트리밍을 지원하는 비디오 플레이어 컴포넌트
 */ var VideoPlayer = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _props_src = props.src, src = _props_src === void 0 ? '' : _props_src, poster = props.poster, _props_width = props.width, width = _props_width === void 0 ? '100%' : _props_width, _props_height = props.height, height = _props_height === void 0 ? 'auto' : _props_height, _props_autoPlay = props.autoPlay, autoPlay = _props_autoPlay === void 0 ? true : _props_autoPlay, _props_controls = props.controls, controls = _props_controls === void 0 ? true : _props_controls, _props_muted = props.muted, muted = _props_muted === void 0 ? true : _props_muted, _props_loop = props.loop, loop = _props_loop === void 0 ? false : _props_loop, _props_className = props.className, className = _props_className === void 0 ? '' : _props_className, onPlay = props.onPlay, onPause = props.onPause, onEnded = props.onEnded, onLoadedData = props.onLoadedData, onError = props.onError, _props_fileBlob = props.fileBlob, fileBlob = _props_fileBlob === void 0 ? null : _props_fileBlob, mediaIndex = props.mediaIndex;
    // React Hooks
    var containerRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isFullscreen = _useState[0], setIsFullscreen = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), errorMessage = _useState1[0], setErrorMessage = _useState1[1];
    var handleVideoError = useCallback(function(err) {
        console.error('useVideoPlayer에서 에러 발생:', err.message);
        setErrorMessage(err.message || '비디오 재생 중 오류 발생');
        if (props.onError) props.onError(err, props.mediaIndex);
    }, [
        props.onError,
        props.mediaIndex
    ]);
    // useVideoPlayer 훅 사용
    var _useVideoPlayer = useVideoPlayer({
        src: src,
        poster: poster,
        autoPlay: autoPlay,
        controls: controls,
        muted: muted,
        loop: loop,
        fileBlob: fileBlob,
        onError: handleVideoError,
        onLoadedData: function() {
            setErrorMessage(null);
            if (props.onLoadedData) props.onLoadedData();
        },
        onPlay: onPlay,
        onPause: onPause,
        onEnded: onEnded
    }), internalVideoRef = _useVideoPlayer.videoRef, videoError = _useVideoPlayer.error, loading = _useVideoPlayer.loading, isHovered = _useVideoPlayer.isHovered, onMouseEnter = _useVideoPlayer.onMouseEnter, onMouseLeave = _useVideoPlayer.onMouseLeave, videoUrl = _useVideoPlayer.videoUrl, posterUrl = _useVideoPlayer.posterUrl, srcForVideoElement = _useVideoPlayer.srcForVideoElement, nativeOnError = _useVideoPlayer.nativeOnError, nativeOnLoadedData = _useVideoPlayer.nativeOnLoadedData, nativeOnLoadStart = _useVideoPlayer.nativeOnLoadStart;
    // useImperativeHandle를 사용하여 외부 ref와 내부 videoRef 연결
    useImperativeHandle(ref, function() {
        return internalVideoRef.current;
    }, [
        internalVideoRef
    ]);
    // Removed useApi - ui-atoms should not have API dependencies
    // 에러 상태 동기화
    useEffect(function() {
        if (videoError) {
            setErrorMessage(videoError);
        }
    }, [
        videoError
    ]);
    // 전체 화면 상태 변경 감지
    useEffect(function() {
        var handleFullscreenChange = function() {
            setIsFullscreen(Boolean(document.fullscreenElement));
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        return function() {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, []);
    // 이벤트 핸들러
    var handleFullscreenToggle = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!(!document.fullscreenElement && containerRef.current)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            containerRef.current.requestFullscreen()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (!document.fullscreenElement) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            document.exitFullscreen()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        console.error('전체화면 전환 에러:', err);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var preventBubbling = useCallback(function(e) {
        e.stopPropagation();
    }, []);
    var getErrorMessage = useCallback(function() {
        return errorMessage || videoError || '';
    }, [
        errorMessage,
        videoError
    ]);
    // 스타일 정의
    var containerStyle = {
        backgroundColor: '#000',
        borderRadius: '8px',
        overflow: 'hidden',
        position: 'relative',
        width: width,
        height: height
    };
    var videoWrapperStyle = {
        backgroundColor: '#000',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };
    var videoStyle = {
        width: '100%',
        height: '100%',
        objectFit: controls ? 'contain' : 'cover',
        backgroundColor: '#000'
    };
    // 렌더링
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        style: containerStyle,
        className: clsx('video-player-container', {
            'has-error': !!(errorMessage || videoError),
            'loading': loading,
            'error': !!errorMessage
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            width: '100%',
            height: '100%',
            position: 'relative'
        }
    }, loading && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            zIndex: 10,
            backdropFilter: 'blur(4px)'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "spinner",
        style: {
            width: '40px',
            height: '40px',
            border: '3px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '50%',
            borderTop: '3px solid #fff',
            animation: 'spin 1s linear infinite'
        }
    })), errorMessage || videoError ? /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            padding: '20px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white'
        }
    }, /*#__PURE__*/ React.createElement("p", {
        style: {
            margin: '0 0 15px 0',
            textAlign: 'center'
        }
    }, getErrorMessage())) : /*#__PURE__*/ React.createElement("div", {
        style: videoWrapperStyle
    }, /*#__PURE__*/ React.createElement(StyledVideo, {
        ref: internalVideoRef,
        src: srcForVideoElement,
        poster: posterUrl,
        autoPlay: autoPlay,
        controls: true,
        muted: muted,
        loop: loop,
        playsInline: true,
        style: videoStyle,
        onLoadStart: nativeOnLoadStart,
        onLoadedData: nativeOnLoadedData,
        onError: nativeOnError,
        onPlay: onPlay,
        onPause: onPause,
        onEnded: onEnded
    }, "브라우저가 비디오 태그를 지원하지 않습니다."))), !controls && isHovered && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'absolute',
            bottom: '15px',
            right: '15px',
            zIndex: 20,
            opacity: isFullscreen ? 0 : 1,
            transition: 'opacity 0.3s ease'
        }
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: handleFullscreenToggle,
        "aria-label": isFullscreen ? '전체화면 종료' : '전체화면 보기',
        style: {
            background: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            border: 'none',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.2s ease'
        },
        onMouseOver: function(e) {
            return e.currentTarget.style.background = 'rgba(0, 0, 0, 0.8)';
        },
        onMouseOut: function(e) {
            return e.currentTarget.style.background = 'rgba(0, 0, 0, 0.6)';
        }
    }, isFullscreen ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
    })) : /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
    })))));
});
// 디버깅을 위한 displayName 추가
VideoPlayer.displayName = 'VideoPlayer';
// 컴포넌트를 memo로 감싸고 ErrorBoundary와 함께 export
var MemoizedVideoPlayer = /*#__PURE__*/ memo(VideoPlayer);
// WrappedVideoPlayer도 forwardRef로 감싸서 ref를 받을 수 있도록 함
var WrappedVideoPlayer = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ React.createElement(VideoPlayerErrorBoundary, null, /*#__PURE__*/ React.createElement(MemoizedVideoPlayer, _object_spread_props(_object_spread({}, props), {
        ref: ref
    })));
});
// 디버깅을 위한 displayName 추가
WrappedVideoPlayer.displayName = 'WrappedVideoPlayer';
export default WrappedVideoPlayer;
